import { fetchVideoUrl } from "@apis/http/api";
import { ApiStatus } from "@pages/aiStudio/ScriptExport/hooks";
import { useState } from "react";

export const useVideoURL = () => {
  const [videoURL, setVideoURL] = useState<ApiStatus>({ data: "", status: "idle", error: null });

  const [urlNotFound, setUrlNotFound] = useState<boolean>(false);

  const requestVideoURL = async (videoId: string, videoSource: string = "Kalodata") => {
    if (videoId) {
      setVideoURL({ data: "", status: "loading", error: null });
      try {
        const data: any = await fetchVideoUrl({ id: videoId, videoSource } as any);
        if (data?.url) {
          setVideoURL({ data: data?.url, status: "succeeded", error: null });
        } else {
          setVideoURL({ data: "", status: "failed", error: null });
        }
      } catch (err: any) {
        if (err.code === "1053") {
          setUrlNotFound(true);
        }
        setVideoURL({ data: "", status: "failed", error: err as any });
      }
    }
  };

  return { videoURL, setVideoURL, requestVideoURL, urlNotFound };
};
